import { css } from '@emotion/react';
import { Headers } from '@frontend/header';
import { useTranslation } from '@frontend/i18n';
import { useIsCompactMode } from '@frontend/responsiveness';
import { useAppScopeStore } from '@frontend/scope';
import { CallHistoryActionBar } from './call-history-action-bar';

export const CallHistoryHeader = () => {
  const { t } = useTranslation('calls');
  const isCompactMode = useIsCompactMode();
  const { selectedLocationIds } = useAppScopeStore();
  const isMultiLocationSelected = selectedLocationIds.length > 1;

  if (!isCompactMode || isMultiLocationSelected) {
    return <Headers.RouterHeader title={t('Call History')} />;
  }

  return (
    <div
      css={css`
        display: flex;
        width: 100%;
        justify-content: space-between;
        align-items: center;
      `}
    >
      <Headers.RouterHeader title={t('Call History')} />
      <CallHistoryActionBar />
    </div>
  );
};
